function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable no-console */
import { EventTarget } from 'event-target-shim';
import Log from "./Log.js";
export var LOG_PROXY_TYPE;

// We need to cast our CustomEvent so it's happy with event-target-shim
(function (LOG_PROXY_TYPE) {
  LOG_PROXY_TYPE["DEBUG"] = "D";
  LOG_PROXY_TYPE["LOG"] = "L";
  LOG_PROXY_TYPE["WARN"] = "W";
  LOG_PROXY_TYPE["ERROR"] = "E";
  LOG_PROXY_TYPE["UNCAUGHT_ERROR"] = "U";
})(LOG_PROXY_TYPE || (LOG_PROXY_TYPE = {}));
function makeEvent(type, detail) {
  return new CustomEvent(type, {
    detail
  });
}
export class LogProxy {
  constructor() {
    _defineProperty(this, "isEnabled", false);
    _defineProperty(this, "debug", void 0);
    _defineProperty(this, "log", void 0);
    _defineProperty(this, "warn", void 0);
    _defineProperty(this, "error", void 0);
    _defineProperty(this, "eventTarget", void 0);
    _defineProperty(this, "handleUncaughtError", event => {
      var messages = [];
      if (event.error != null) {
        messages.push(event.error);
      }
      if (event.message) {
        messages.push(event.message);
      }
      this.eventTarget.dispatchEvent(makeEvent(LOG_PROXY_TYPE.UNCAUGHT_ERROR, messages));
    });
    _defineProperty(this, "handleUncaughtRejection", event => {
      var messages = [];
      if (event.promise != null) {
        messages.push(event.promise.toString());
      }
      if (event.reason) {
        messages.push(event.reason);
      }
      this.eventTarget.dispatchEvent(makeEvent(LOG_PROXY_TYPE.UNCAUGHT_ERROR, messages));
    });
    this.debug = console.debug;
    this.log = console.log;
    this.warn = console.warn;
    this.error = console.error;
    this.eventTarget = new EventTarget();
  }
  enable() {
    var _this = this;
    if (this.isEnabled) {
      return;
    }
    console.debug = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this.eventTarget.dispatchEvent(makeEvent(LOG_PROXY_TYPE.DEBUG, args));
      _this.debug.apply(console, args);
    };
    console.log = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this.eventTarget.dispatchEvent(makeEvent(LOG_PROXY_TYPE.LOG, args));
      _this.log.apply(console, args);
    };
    console.warn = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      _this.eventTarget.dispatchEvent(makeEvent(LOG_PROXY_TYPE.WARN, args));
      _this.warn.apply(console, args);
    };
    console.error = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      _this.eventTarget.dispatchEvent(makeEvent(LOG_PROXY_TYPE.ERROR, args));
      _this.error.apply(console, args);
    };
    window.addEventListener('error', this.handleUncaughtError);
    window.addEventListener('unhandledrejection', this.handleUncaughtRejection);

    // This forces logger to update its reference to the overriding functions instead of the original
    Log.setLogLevel(Log.level);
    this.isEnabled = true;
  }
  disable() {
    if (!this.isEnabled) {
      return;
    }
    console.debug = this.debug;
    console.log = this.log;
    console.warn = this.warn;
    console.error = this.error;
    window.removeEventListener('error', this.handleUncaughtError);
    window.removeEventListener('unhandledrejection', this.handleUncaughtRejection);
    Log.setLogLevel(Log.level);
    this.isEnabled = false;
  }
  addEventListener(type, listener) {
    // The cast as EventListener is a dumb TypeScript issue
    this.eventTarget.addEventListener(type, listener);
  }
  removeEventListener(type, listener) {
    this.eventTarget.removeEventListener(type, listener);
  }
}
export default LogProxy;
//# sourceMappingURL=LogProxy.js.map